<template>
  <router-link :to="backPath">
    <LeftCircleOutlined />
    返回
  </router-link>
  <!--<a-breadcrumb>-->
  <!--    <a-breadcrumb-item>-->
  <!--        <router-link :to="backPath">-->
  <!--            <LeftCircleOutlined />-->
  <!--            {{ backName }}-->
  <!--        </router-link>-->
  <!--    </a-breadcrumb-item>-->
  <!--    <a-breadcrumb-item>-->
  <!--        {{ currentName }}-->
  <!--    </a-breadcrumb-item>-->
  <!--</a-breadcrumb>-->
</template>

<script lang="ts" type="text/tsx">
import {
  LeftCircleOutlined
} from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';

export default {
  name: 'page_breadcrumb',
  components: {
    LeftCircleOutlined
  },
  props: [
    'backName',
    'backPath',
    'currentName',
  ],
  methods: {
    /**
     * 点击面包屑
     *
     */
    clickBreadcrumb(): void {
      console.log(arguments);
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}public/';

a {
  display: block;
  width: 55px;
  margin: 10px 0 0;
  color: @color_12;
  
  &:hover {
    color: @color_6;
  }
  
  .anticon {
    margin-right: 2px;
  }
}

//.ant-breadcrumb {
//    overflow: hidden;
//    margin: 15px 0 0;
//
//    &:deep(> span:last-child) {
//        color: rgba(0, 0, 0, 0.45);
//    }
//
//    &:deep(span) {
//        overflow: hidden;
//        float: left;
//        display: block;
//
//        .ant-breadcrumb-link {
//            display: block;
//            max-width: 150px;
//            .ellipsis();
//
//            a {
//                color: rgba(0, 0, 0, 0.85);
//
//                &:hover {
//                    color: @color_6;
//                }
//            }
//
//            .anticon {
//                margin-right: 5px;
//                .transform(translateY(4px));
//            }
//        }
//
//        .ant-breadcrumb-separator {
//            vertical-align: top;
//        }
//    }
//}
</style>